<template>
    <div class="landing">
        <el-row>
            <div class="landing-header-container">
                <Ticker />
                <Header class="landing-header">
                    <div class="landing-header-left" v-if="!isMobile()">
                        <div class="landing-header-title">
                            Chicago Athenaeum Museum of Architecture and Design
                        </div>
                        <div class="landing-header-title">
                            European Centre for Architecture Art Design and
                            Urban Studies
                        </div>
                    </div>
                    <div class="landing-header-middle">
                        <a href="https://awardapplication.com/">
                            <div class="landing-header-title">
                                TCA - ECADUS <br />
                                AWARDS SUBMISSION PAGE
                            </div>
                        </a>
                    </div>
                </Header>
            </div>
        </el-row>
        <el-row
            style="margin-top: 60px; display: flex; justify-content: center"
        >
            <div style="width: 1600px">
                <h1><strong>Terms and conditions</strong></h1>
                <p>
                    This Terms and Conditions of Access and Use Agreement (the
                    &ldquo;Agreement&rdquo;) applies to The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), as well as our subsidiaries and
                    affiliates. This Agreement describes the terms and
                    conditions and the general principles applicable to your
                    access and use of websites, social media sites, pages,
                    e-newsletters, surveys, forums, ratings and reviews,
                    accounts and applications owned, operated or licensed by or
                    on behalf of The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com), If you
                    do not agree to these terms and conditions of access and
                    use, you should not access or use any The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site.
                </p>
                <p>
                    By accessing or using a The Chicago Athenaeum, European
                    Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site, you intend to and expressly
                    agree to be bound by all the terms and conditions of this
                    Agreement and the Privacy Policy, which include those terms
                    and conditions expressly set out below and those
                    incorporated by reference. The Chicago Athenaeum, European
                    Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), reserves the right to change or
                    modify any of the terms and conditions contained in this
                    Agreement at any time and in its sole discretion without
                    further notice, effective upon including the revisions on a
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), Site. Your continued use
                    of a The Chicago Athenaeum, European Centre and Metropolitan
                    Arts Press Ltd. (awardapplication.com), Site following the
                    changes or modifications will constitute your acceptance of
                    such changes or modifications. Therefore, you should
                    frequently review this Agreement and the Privacy Policy from
                    time-to-time to understand the terms and conditions that
                    apply to your access and use of a The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site.
                </p>
                <h2>
                    <strong>General Terms.</strong>
                </h2>
                <ul>
                    <li>
                        <strong>Use of Site</strong><br />In consideration of
                        your acceptance of this Agreement and the&nbsp;<a
                            href="http://globaldesignnews.com/privacy-policy/"
                            >Privacy Policy</a
                        >, The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        grants you a limited non-exclusive revocable license to
                        access and make personal and non-commercial use of the
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com),. Sites, provided
                        you do not modify, alter, or download (other than page
                        caching) any portion of it unless otherwise specifically
                        provided herein or you have obtained written
                        authorization in advance from The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), The permission granted to you
                        shall terminate automatically and immediately if you
                        breach any of the terms and conditions set forth in this
                        Agreement. The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        reserves the right to modify or remove any materials,
                        products, or services listed on the The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), Sites at any time without
                        further notice. All rights not expressly granted herein
                        are expressly reserved by The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com),
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Prohibited Use of Site</strong><br />You shall
                        not make any commercial use of the The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), Sites or their contents,
                        product listings, descriptions, or prices. You further
                        agree not to download or copy any content or product
                        information for the benefit of any third party or use
                        any data mining, robots, or similar data gathering and
                        extraction tools. The The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Sites, or any portion thereof,
                        may not be reproduced, duplicated, copied, displayed,
                        sold, resold, visited, or exploited for any commercial
                        purpose without the express written consent of The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), You agree not to
                        interfere, disrupt, or attempt to gain unauthorized
                        access to the The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        Sites, or any other related computer network. You
                        further agree not to disseminate, store, or transmit
                        viruses, Trojan horses, or any malicious code or program
                        or engage in any other activity deemed by The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), to be in conflict with the
                        spirit or intent of this Agreement. You agree to use the
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com), Sites only for
                        lawful purposes. You are prohibited from posting on or
                        transmitting through the Vista The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Sites any material or content
                        that is unlawful, harmful, threatening, abusive,
                        harassing, defamatory, vulgar, obscene, sexually
                        explicit, profane, hateful, or offensive, or that is
                        otherwise objectionable, including, but not limited to,
                        any material or content encouraging conduct that may
                        constitute a criminal offense, give rise to civil
                        liability, or otherwise violate any applicable local,
                        state, national, or international law. The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), reserves the right to
                        remove any postings or content in violation of this
                        Agreement.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Equipment</strong><br />You shall be solely
                        responsible for providing, maintaining, and ensuring
                        compatibility with the The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Sites including all hardware,
                        software, electrical and other physical requirements for
                        your use of the The Chicago Athenaeum, European Centre
                        and Metropolitan Arts Press Ltd. (awardapplication.com),
                        Sites, including, without limitation,
                        telecommunications, Internet access connections, web
                        browsers or other equipment, and programs and services
                        required to access and use the The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Sites.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Correction of Errors and Inaccuracies</strong
                        ><br />The information on this website may contain
                        typographical errors or inaccuracies and may not be
                        complete or current. We therefore reserve the right to
                        correct any errors, inaccuracies or omissions and to
                        change or update information at any time without prior
                        notice (including after you have submitted your order).
                        Please note that such errors, inaccuracies or omissions
                        may relate to product description, pricing and
                        availability. We apologize for any inconvenience this
                        may cause you.
                    </li>
                </ul>
                <ol>
                    <li>
                        <strong>Accessibility</strong><br />You acknowledge and
                        agree that at times the The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Sites may be inaccessible or
                        inoperable for any reason whatsoever, including, without
                        limitation: (i) equipment malfunctions; (ii) periodic
                        maintenance procedures or repairs which The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), may undertake from time to
                        time; or (iii) causes which are beyond the control of
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com), or which are not
                        reasonably foreseeable.
                    </li>
                </ol>
                <ul>
                    <li>
                        <h2>
                            <strong
                                ><strong>Intellectual Property</strong></strong
                            >
                        </h2>
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Trademarks</strong><br />The trademarks, service
                        marks, brand names, and logos appearing on the The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), Sites
                        (&ldquo;Marks&rdquo;) are owned or licensed by The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), and its affiliates.
                        Nothing herein shall be construed as granting any
                        license or right to use the Marks without the express
                        written permission of the owner. You may not frame or
                        utilize framing techniques to enclose any Marks or use
                        any meta tags or any other &ldquo;hidden text&rdquo;
                        utilizing the Marks without the express written consent
                        of The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Copyrighted Works</strong><br />Copyrights in
                        content provided on the The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Sites, including, but not
                        limited to, images, video, photos, electronic art,
                        animations, graphics, sounds, audio, information and
                        data, communication programs, electronic mail services,
                        and user interfaces, executable code, and data
                        formatted, organized, and collected in a variety of
                        forms, including layouts, pages, screens, directories,
                        and databases (hereafter &ldquo;Copyrighted
                        Works&rdquo;) are exclusively owned or licensed by The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), and its affiliates,
                        and are protected by U.S. and international copyright
                        laws. Except as stated herein, you agree that you will
                        not copy, reproduce, modify, alter, create derivative
                        works from, distribute, display, post, or transmit any
                        Copyrighted Works (except for your personal, private,
                        non-commercial use) in any form or by any means,
                        including, but not limited to, electronic, mechanical,
                        photocopying, recording, or otherwise, without the prior
                        written permission of The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), and any appropriate third party
                        as applicable.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Copyright Infringement</strong><br />If you are
                        a copyright owner or an agent thereof and believe that
                        any content on the Site infringes upon your copyrights,
                        you may submit a notification pursuant to the Digital
                        Millennium Copyright Act (&ldquo;DMCA&rdquo;) by
                        providing The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        with the following information in writing (see 17 U.S.C
                        Section 512(c)(3) for further detail):
                    </li>
                </ul>
                <ol>
                    <li>
                        physical or electronic signature of a person authorized
                        to act on behalf of the owner of an exclusive right that
                        is allegedly infringed;<br /><strong>b.</strong>
                        identification of the copyrighted work claimed to have
                        been infringed, or if multiple copyrighted works at a
                        single online site are covered by a single notification,
                        a representative list of such works at that site;<br /><strong
                            >c.</strong
                        >
                        identification of the material that is claimed to be
                        infringing or to be the subject of infringing activity
                        and that is to be removed or access to which is to be
                        disabled and information reasonably sufficient to permit
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com),. to locate the
                        material;<br /><strong>d.</strong> information
                        reasonably sufficient to permit The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), to contact you, such as an
                        address, telephone number, and, if available, an
                        electronic mail;<br /><strong>e.</strong> a statement
                        that you have a good faith belief that use of the
                        material in the manner complained of is not authorized
                        by the copyright owner, its agent, or the law; and<br /><strong
                            >f.</strong
                        >
                        a statement that the information in the notification is
                        accurate, and under penalty of perjury, that you are
                        authorized to act on behalf of the owner of an exclusive
                        right that is allegedly infringed. You may contact The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), designated Copyright
                        Agent by selecting &ldquo;<strong
                            >Copyright Inquiry</strong
                        >&rdquo; in the dropdown menu in the form found on our
                        <a href="http://globaldesignnews.com/contact/"
                            >Contact Us</a
                        >
                        page, by email at&nbsp;<a
                            href="mailto:contact@globaldesignnews.com"
                            >contact@globaldesignnews.com</a
                        >
                        or by&nbsp;writing to The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com),&nbsp;
                    </li>
                </ol>
                <ul>
                    <li>
                        <strong
                            ><strong
                                >News Media Exception to Advance Written
                                Permission</strong
                            ><br />Notwithstanding&nbsp;anything to the contrary
                            herein, images from the The Chicago Athenaeum,
                            European Centre and Metropolitan Arts Press Ltd.
                            (awardapplication.com), Image Gallery, videos from
                            the The Chicago Athenaeum, European Centre and
                            Metropolitan Arts Press Ltd. (awardapplication.com),
                            Video Gallery, and product images and logos provided
                            in the The Chicago Athenaeum, European Centre and
                            Metropolitan Arts Press Ltd. (awardapplication.com),
                            Image Resource Library may be reproduced (but not
                            modified or altered) by news reporting organisations
                            for news reporting purposes, without advance prior
                            written permission from The Chicago Athenaeum,
                            European Centre and Metropolitan Arts Press Ltd.
                            (awardapplication.com), provided the reproduction is
                            accompanied by notice that it has been reproduced
                            with permission from The Chicago Athenaeum, European
                            Centre and Metropolitan Arts Press Ltd.
                            (awardapplication.com),</strong
                        >
                    </li>
                </ul>
                <ol>
                    <li>
                        <strong>Confidential Information</strong
                        ><strong><br /></strong>Do not use the The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), Sites as a means of
                        submitting information you consider to be confidential
                        or proprietary unless you are placing an order in which
                        case some personal information is required. You grant to
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com), a non-exclusive
                        license to use any review or feedback content that
                        constitutes a &ldquo;covered communication&rdquo; as
                        defined in the Consumer Review Fairness Act
                        (&ldquo;Review&rdquo;). Except as otherwise expressly
                        provided herein or in a written agreement with The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), applicable to your
                        particular use of a The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Site, you agree that any
                        material that does not constitute a Review, including
                        but not limited to questions, comments, suggestions,
                        ideas, inventions, plans, notes, drawings, photos,
                        original or creative materials or other information,
                        provided by you in the form of e-mail or submissions to
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com), or postings on
                        the The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        Sites (herein &ldquo;Material&rdquo;), are
                        non-confidential (subject to the The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Privacy Policy) and will be
                        considered a contribution to The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), for its free and further use in
                        its sole discretion. The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), shall be entitled to the
                        unrestricted use of Material for any purpose, commercial
                        or otherwise, without any compensation to you.
                    </li>
                </ol>
                <ul>
                    <li>
                        <h2>
                            <strong><strong>Links</strong></strong>
                        </h2>
                    </li>
                </ul>
                <p>
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), Sites may provide links
                    to other websites maintained by third parties. You
                    acknowledge and agree that such links are provided for your
                    convenience only and do not reflect any endorsement,
                    affiliation, relationship, or sponsorship by The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), with respect to the provider of such
                    linked site or the quality, reliability, or any other
                    characteristic or feature of such linked site. You further
                    acknowledge and agree that The Chicago Athenaeum, European
                    Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), is not responsible in any manner
                    (including without limitation with respect to any loss or
                    injury you may suffer) for any matter associated with the
                    linked site, including without limitation, the content
                    provided on or through any such linked site or your reliance
                    thereon.
                    <strong
                        >The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com), MAKES NO
                        REPRESENTATIONS OR WARRANTIES WITH RESPECT TO ANY LINKED
                        SITE. YOUR USE OF ANY LINKED SITE IS SOLELY AT YOUR OWN
                        RISK.</strong
                    >
                    In addition, you should be aware that your use of any
                    non-The Chicago Athenaeum, European Centre and Metropolitan
                    Arts Press Ltd. (awardapplication.com), Site is subject to
                    the terms and conditions applicable to that site, including
                    the privacy policies of such site. If a third-party links to
                    a The Chicago Athenaeum, European Centre and Metropolitan
                    Arts Press Ltd. (awardapplication.com), Site, it is not
                    necessarily an indication of endorsement, affiliation,
                    relationship, or sponsorship by or with The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), may not even be aware that a third
                    party has linked to the The Chicago Athenaeum, European
                    Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site.
                </p>
                <p><strong>Third-party links</strong></p>
                <p>
                    Occasionally, at our discretion, we may include or offer
                    third-party products or services on our website. These
                    third-party sites have separate and independent privacy
                    policies. We therefore have no responsibility or liability
                    for the content and activities of these linked sites.
                    Nonetheless, we seek to protect the integrity of our site
                    and welcome any feedback about these sites.
                </p>
                <p><strong>Google</strong></p>
                <p>
                    Google&rsquo;s advertising requirements can be summed up
                    by&nbsp;Google&rsquo;s Advertising Principles. They are put
                    in place to provide a positive experience for users. They
                    are available&nbsp;<a
                        href="https://support.google.com/google-ads"
                        >here</a
                    >.
                </p>
                <p>We use Google AdSense Advertising on our website.</p>
                <p>
                    Google, as a third-party vendor, uses cookies to serve ads
                    on our site. Google&rsquo;s use of the DART cookie enables
                    it to serve ads to our users based on previous visits to our
                    site and other sites on the Internet. Users may opt-out of
                    the use of the DART cookie by visiting the Google Ad and
                    Content Network privacy policy.
                </p>
                <p><strong>We have implemented the following:</strong></p>
                <ul>
                    <li>
                        <strong>Demographics and Interests Reporting</strong>
                    </li>
                </ul>
                <p>
                    We, along with third-party vendors such as Google use
                    first-party cookies (such as the Google Analytics cookies)
                    and third-party cookies (such as the DoubleClick cookie) or
                    other third-party identifiers together to compile data
                    regarding user interactions with ad impressions and other ad
                    service functions as they relate to our website.
                </p>
                <p><strong>Opting out:</strong></p>
                <p>
                    Users can set preferences for how Google advertises to you
                    using the&nbsp;Google Ad Settings&nbsp;page. Alternatively,
                    you can opt out by using the Google Analytics Opt Out
                    Browser add on.
                </p>
                <p><strong>We use cookies to:</strong></p>
                <ul>
                    <li>
                        Compile aggregate data about site traffic and site
                        interactions in order to offer better site experiences
                        and tools in the future. We may also use trusted
                        third-party services that track this information on our
                        behalf.
                    </li>
                </ul>
                <p>
                    You can choose to have your computer warn you each time a
                    cookie is being sent, or you can choose to turn off all
                    cookies. You do this through your browser settings. Since
                    browser is a little different, look at your browser&rsquo;s
                    Help Menu to learn the correct way to modify your cookies.
                </p>
                <p>
                    If you turn cookies off, some features will be disabled. It
                    won&rsquo;t affect the user&rsquo;s experience that make
                    your site experience more efficient and may not function
                    properly.
                </p>
                <p>However, you will still be able to place orders.</p>
                <ul>
                    <li>
                        <h2>
                            <strong><strong>Product Sales</strong></strong>
                        </h2>
                    </li>
                </ul>
                <p>
                    These terms apply to all product sales from the The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Sites and may be supplemented by
                    more specific terms on the individual Vista Site where an
                    order is placed.
                </p>
                <ol>
                    <li>
                        <strong>Orders</strong><br />All products offered for
                        sale are subject to availability and The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), acceptance of your order.
                        After you place an order through a The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), Site, we will send you an
                        email acknowledging your order. This order
                        acknowledgment means that your order has been received;
                        it does not mean that your order has been accepted,
                        shipped, or that the price of an item has been
                        confirmed, nor does it constitute confirmation of our
                        offer to sell; we are simply confirming that we received
                        your order. Upon shipment of your order, we will send
                        you an email. The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com), may
                        also require additional information prior to accepting
                        or processing any order.
                    </li>
                </ol>
                <p>
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), reserves the right at any
                    time to accept, decline or cancel any order or limit order
                    quantity for any reason. If we cancel an order after you
                    have already been billed, we will refund the billed amount.
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), uses its best efforts to
                    fulfill orders, however, there may be instances in which a
                    product is out of stock or unavailable, in which case The
                    Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), will contact you for
                    direction on whether you wish to select another order or
                    cancel your existing order.
                </p>
                <p>
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), may revise, discontinue
                    or modify products at any time without prior notice to you
                    and products may become unavailable without notice. The
                    Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), shall have no liability
                    of any kind if any product is not available.
                </p>
                <ul>
                    <li>
                        <strong><strong>Fulfilment</strong></strong
                        ><br />Most product orders are shipped by a third-party
                        fulfilment service provider. Delivery lead times vary,
                        but most orders will be shipped within 10 working days.
                        The delivery charge varies depending on the size and
                        weight of the item. These charges will be included in
                        the Shipping and Handling of your order. If eligible for
                        shipment to Hawaii and Alaska, or to international
                        destinations, special rates apply. Oversized and
                        extremely heavy items are marked on their product
                        information pages as requiring a special delivery
                        charge. Title to and risk of loss of product will pass
                        to you upon our delivery to the carrier. Shipping times
                        are estimates only, and not a guarantee that the product
                        will be delivered on the specified date. We will not be
                        liable for any loss or expense which you may incur as a
                        result of any delay in the delivery of your order. When
                        ordering more than one item, please note your items may
                        come in different shipments. The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), assumes no liability for
                        damaged, lost or stolen shipments. It is your
                        responsibility to ensure parcels can be delivered free
                        from theft or exposure to rain, snow, excessive humidity
                        or temperature extreme. Claims for incorrect or missed
                        shipments must be made to The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Customer Support within 20 days
                        of order acknowledgment/shipment or are deemed waived. >
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Credit Card Information</strong><br />You may be
                        asked to supply certain information relevant to your
                        purchase of product through a The Chicago Athenaeum,
                        European Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Site, including credit card
                        number, the expiration date, your billing address and
                        your shipping information. By submitting such
                        information, you grant The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), the right to provide such
                        information to our third party-fulfillment service
                        provider to facilitate the transaction. You agree to pay
                        all charges that you incur on the Sites at the prices in
                        effect when incurred, including without limitations any
                        shipping and handling charges and taxes. You represent
                        and warrant that you have the legal right to use any
                        credit cards used in connection with any transaction.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Pricing</strong><br />Prices shown are in either
                        U.S. dollars or Euros. The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), reserves the right to change
                        prices for products displayed on the Site at any time,
                        and to correct pricing errors that may inadvertently
                        occur. Despite our best efforts, a small number of the
                        items on our Website may be mispriced. Rest assured,
                        however, that we verify prices as part of our shipping
                        procedures. If an item&rsquo;s correct price is lower
                        than our stated price, we charge the lower amount and
                        ship you the item. If an item&rsquo;s correct price is
                        higher than our stated price, we will, at our
                        discretion, either (i) contact you for instructions
                        about whether you wish to pay the correct higher price
                        before shipping or (ii) cancel your order and notify you
                        of such cancellation (whether or not the order has been
                        confirmed and your credit card or debit card charged).
                        We cannot confirm the price of an item until your order
                        enters the shipping process, nor will we charge your
                        credit card until your order enters the shipping
                        process. (Please note that your Order Acknowledgment
                        means that your order request has been received; it does
                        not mean that your order has been shipped or that the
                        price of an item has been confirmed.)
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Limited Warranty</strong><br />The extent of any
                        limited warranty for each product is as shipped with the
                        product or as expressly stated on a warranty document on
                        a The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        Site. Any warranty offered is limited to defects in
                        material or workmanship, and&nbsp;<strong
                            >repair or replacement is your exclusive remedy for
                            any defective product. In no event shall we be
                            liable for any special, incidental or consequential
                            damages of any kind arising out of the purchase or
                            use of any product, whether based on contract, tort,
                            statute or otherwise.</strong
                        >Some states do not allow the exclusion or limitation of
                        incidental or consequential damages, so the above
                        limitation or exclusion may not apply to you. This
                        warranty gives you specific legal rights, and you may
                        also have other rights which vary from State to
                        State.&nbsp;<strong
                            >In addition, any warranties implied by law shall in
                            no event extend beyond the duration of the express
                            warranty offered,</strong
                        >if any. Some States do not allow limitations on how
                        long an implied warranty lasts, so the above limitation
                        may not apply to you.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Returns</strong><br />This return policy only
                        applies to orders from a The Chicago Athenaeum, European
                        Centre and Metropolitan Arts Press Ltd.
                        (awardapplication.com), Authorised returns must have a
                        prior return merchandise authorisation (RMA) and may be
                        subject to a restocking fee. Contact Customer Service
                        using the number or email address listed on the The
                        Chicago Athenaeum, European Centre and Metropolitan Arts
                        Press Ltd. (awardapplication.com), Site Customer Support
                        page to obtain an RMA number. All sales of discontinued
                        items, items sold &ldquo;as is,&rdquo; and clearance
                        items are final and may not be returned. You are
                        responsible for any shipping, handling and insurance
                        costs associated with the return item. All authorised
                        returns must be shipped within 30 days of delivery, must
                        be returned unused, complete and in its original
                        packaging and must be accompanied with a copy of the
                        invoice. For your protection, we suggest all returns be
                        sent back by a traceable carrier such as UPS or FedEx.
                        The Chicago Athenaeum, European Centre and Metropolitan
                        Arts Press Ltd. (awardapplication.com), is not
                        responsible for product lost in shipment.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Product Descriptions</strong><br />We attempt to
                        make our product descriptions as accurate as possible.
                        However, we do not warrant that product descriptions or
                        other content is accurate, complete, reliable, current,
                        or error-free. If a product is not as described, your
                        sole remedy is to return it in unused condition.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Compliance with Laws</strong><br />It is your
                        responsibility to ascertain and obey all applicable
                        local, state, federal and international laws (including
                        minimum age requirements) in regard to the possession,
                        use and sale of any item purchased from a The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), Site. By placing an order,
                        you represent that the order is lawful and will be used
                        in a lawful and appropriate manner. In addition, you
                        acknowledge that any goods sold in the U.S. may be
                        subject to the import or export laws of the country in
                        which the goods are sold. Accordingly, you agree to
                        abide by all applicable export laws and regulations, and
                        you represent and warrant that you will not transfer
                        such goods to a foreign national or a foreign
                        destination in violation of law.
                    </li>
                </ul>
                <ol>
                    <li>
                        <strong>Customer Service</strong><br />If you need
                        assistance with an existing order, placing an order,
                        understanding more about a product, or processing a
                        return or exchange, please contact our customer service
                        at the number listed on the Site Customer Support page.
                    </li>
                </ol>
                <ul>
                    <li>
                        <h2>
                            <strong
                                ><strong
                                    >Disclaimer of Warranties</strong
                                ></strong
                            >
                        </h2>
                    </li>
                </ul>
                <p>
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), and its parents,
                    subsidiaries, related companies, agents, officers,
                    directors, employees, successors, assigns, contractors,
                    service providers and affiliates provide the The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Sites &ldquo;as is&rdquo; without
                    warranty of any kind, express or implied, and expressly
                    disclaim any implied warranties of title, merchantability,
                    fitness for a particular purpose, and non-infringement. The
                    Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), and its parents,
                    subsidiaries, related companies, agents, officers,
                    directors, employees, successors, assigns, contractors,
                    service providers and affiliates do not warrant that the
                    operation of the The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com), Sites,
                    or the information, content, or materials included on these
                    The Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), Sites will be
                    uninterrupted or error free. you expressly agree that your
                    use of the The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com), Sites
                    is at your sole risk. to the fullest extent permissible by
                    applicable law, The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com),.
                    disclaims all warranties, express or implied, including, but
                    not limited to, implied warranties of merchantability and
                    fitness for a particular purpose. The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), does not warrant that any The
                    Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), site, or its servers, are
                    free of viruses or other harmful components.
                </p>
                <ul>
                    <li>
                        <h2>
                            <strong
                                ><strong
                                    >Limitation of Liability</strong
                                ></strong
                            >
                        </h2>
                    </li>
                </ul>
                <p>
                    Under no circumstances shall vista outdoor, or its parents,
                    subsidiaries, related companies, agents, officers,
                    directors, employees, successors, assigns, contractors,
                    service providers and affiliates be liable to you or any
                    other person for any indirect, incidental, consequential,
                    special, or punitive damages for any matter arising from or
                    relating to this agreement or your use of the The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Sites, including, without
                    limitation, your use or inability to use a The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site, any changes to or
                    inaccessibility of a The Chicago Athenaeum, European Centre
                    and Metropolitan Arts Press Ltd. (awardapplication.com),
                    Site, delay, failure, unauthorized access to or alteration
                    of any transmission or data, any material or data sent or
                    received or not sent or received, any transaction or
                    agreement entered into through a The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site, or any data or material from a
                    third person accessed on or through a The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site, whether such liability is
                    asserted on the basis of contract, tort, or otherwise.
                </p>
                <ul>
                    <li>
                        <h2>
                            <strong><strong>Indemnification</strong></strong>
                        </h2>
                    </li>
                </ul>
                <p>
                    You agree to indemnify, hold harmless, and defend The
                    Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com),, its parents,
                    subsidiaries, related companies, affiliates, directors,
                    officers, employees, successors, assigns, contractors,
                    service providers and agents from and against any action,
                    cause, claim, damage, debt, demand or liability, including
                    reasonable costs and attorney&rsquo;s fees, asserted by any
                    person, arising out of, or relating to: (i) this Agreement;
                    (ii) your use of a The Chicago Athenaeum, European Centre
                    and Metropolitan Arts Press Ltd. (awardapplication.com),
                    Site, including any data or work transmitted or received by
                    you; and (iii) any prohibited use of a The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site.
                </p>
                <ul>
                    <li>
                        <h2>
                            <strong><strong>Termination</strong></strong>
                        </h2>
                    </li>
                </ul>
                <p>
                    This Agreement is effective upon your acceptance as set
                    forth herein and shall continue in full force until
                    terminated. The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com),
                    reserves the right, in its sole discretion and without
                    notice, at any time and for any reason, to: (i) remove or
                    disable access to all or any portion of any The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site; (ii) suspend your access to or
                    use of all or any portion of any The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), Site; and (iii) terminate this
                    Agreement. Sections 1, 2, 3, 4, 6, 7, 8, 9, and 10, shall
                    survive any termination of this Agreement.
                </p>
                <ul>
                    <li>
                        <h2>
                            <strong><strong>Miscellaneous</strong></strong>
                        </h2>
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Waiver</strong><br />No waiver of any term,
                        provision or condition of this Agreement, whether by
                        conduct or otherwise, in any one or more instances,
                        shall be deemed to be, or shall constitute, a waiver of
                        any other term, provision or condition hereof, whether
                        or not similar, nor shall such waiver constitute a
                        continuing waiver of any such term, provision or
                        condition hereof. No waiver shall be binding unless
                        executed in writing by the party making the waiver.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Severability</strong><br />If any provision of
                        this Agreement is determined to be illegal or
                        unenforceable, then such provision will be enforced to
                        the maximum extent possible and the other provisions
                        will remain fully effective and enforceable.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Law</strong><br />This Agreement is made in and
                        shall be governed and construed by the laws of the State
                        of Illinois, United States of America, without reference
                        to conflicts of laws. If you access a The Chicago
                        Athenaeum, European Centre and Metropolitan Arts Press
                        Ltd. (awardapplication.com), Site from locations outside
                        Iowa or the United States, you are voluntarily and
                        purposefully availing yourself of the laws of the State
                        of Iowa, United States of America, and you are solely
                        responsible for compliance with all your local laws.
                        Access to any The Chicago Athenaeum, European Centre and
                        Metropolitan Arts Press Ltd. (awardapplication.com),
                        Site from locations where such Site&rsquo;s contents may
                        be unlawful is prohibited.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Forum</strong><br />All actions, claims, or
                        disputes arising under or relating to this Agreement
                        shall be brought in the federal or state courts located
                        in Dubuque County, Iowa. You irrevocably submit and
                        consent to the exercise of subject mat Dubuque County,
                        Iowa. You hereby irrevocably waive any and all
                        objections which you may now or hereafter have to the
                        exercise of personal and subject matter jurisdiction by
                        the federal or state courts in Dubuque Count. and to the
                        Dubuque County, Iowa.
                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>Headings</strong><br />The captions and headings
                        of this Agreement are included for ease of reference
                        only and shall be disregarded in interpreting or
                        construing this Agreement.
                    </li>
                </ul>
                <ol>
                    <li>
                        <strong>Entire Agreement</strong><br />This Agreement
                        constitutes the complete and exclusive statement of the
                        agreement between the parties and supersedes any and all
                        prior or contemporaneous communications,
                        representations, statements and understandings, whether
                        oral or written, between the parties.
                    </li>
                </ol>
                <ul>
                    <li>
                        <h2>
                            <strong
                                ><strong
                                    >Password Protected Sites</strong
                                ></strong
                            >
                        </h2>
                    </li>
                </ul>
                <p>
                    If you access a password-protected The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), (&ldquo;Protected Site&rdquo;), you
                    represent that you have been granted access by The Chicago
                    Athenaeum, European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), and agree to take all reasonable
                    precautions to safeguard the confidentiality of the content
                    and all information accessed on the Protected Site,
                    including without limitation the password (collectively, the
                    &ldquo;<strong>Proprietary Information</strong>,&rdquo;
                    exercising at least a degree of care suitable for the
                    sensitivity The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com), of any
                    unauthorized use or disclosure of the Proprietary
                    Information, and to take all necessary actions to prevent
                    use or disclosure of the Proprietary Information in breach
                    of this Agreement or applicable law.
                </p>
                <p>
                    When accessing a Protected Site, you are entirely
                    responsible for maintaining the confidentiality of your
                    password and account and for any and all activities that
                    occur under your account. You agree to (a) immediately
                    notify The Chicago Athenaeum, European Centre and
                    Metropolitan Arts Press Ltd. (awardapplication.com), of any
                    unauthorized use of your account or any other breach of
                    security of which you become aware, and (b) exit completely
                    from your account at the end of each online session. The
                    Chicago Athenaeum, European Centre and Metropolitan Arts
                    Press Ltd. (awardapplication.com), will not be liable for
                    any loss that you or your employer may incur as a result of
                    someone else using your password or account, either with or
                    without your knowledge. However, you could be held liable
                    for losses incurred by The Chicago Athenaeum, European
                    Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com), or another party due to someone else
                    using your account or password. You may not use anyone
                    else&rsquo;s account at any time without the permission of
                    the account holder.
                </p>
                <p><strong>COMPLIANCE CERTIFICATE</strong></p>
                <p>
                    <strong>California Residents:</strong> Do Not Sell My Info
                </p>
                <p>
                    We do not sell, rent, or intentionally disclose any Personal
                    Information, including its contents or your use of this
                    Site, without your consent. Check the The Chicago Athenaeum,
                    European Centre and Metropolitan Arts Press Ltd.
                    (awardapplication.com),
                    <a href="http://globaldesignnews.com/privacy-policy/"
                        >Privacy Policy</a
                    >&nbsp;for details.
                </p>
                <p>
                    The California Consumer Privacy Act states that consumers
                    have the right to opt out of the sale of their personal
                    information.
                </p>
                <p>
                    Submit your request to opt out of the sale of your personal
                    information at curatorial@chicagoathenaeum.org
                </p>
            </div>
        </el-row>
        <el-row>
            <footer>
                <!-- Footer main -->
                <section class="ft-main">
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Awards Organizers</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://www.chi-athenaeum.org/"
                                    target="_blank"
                                    >The Chicago Athenaeum</a
                                >
                            </li>
                            <li>
                                <a
                                    href="http://europeanarch.eu/"
                                    target="_blank"
                                    >The European Centre</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Legal</h2>
                        <ul>
                            <li>
                                <router-link
                                    :to="{
                                        name: 'terms-and-conditions',
                                    }"
                                    target="_blank"
                                >
                                    Terms & Conditions
                                </router-link>
                            </li>
                            <li>
                                <router-link
                                    :to="{
                                        name: 'refund-policy',
                                    }"
                                    target="_blank"
                                >
                                    Refund Policy
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Connect</h2>
                        <ul>
                            <li>
                                <a
                                    href="https://www.instagram.com/thechicagoathenaeummuseum/"
                                    target="_blank"
                                    >Instagram</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm"
                                    target="_blank"
                                    >Facebook</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.youtube.com/@thechicagoathenaeummuseum"
                                    target="_blank"
                                    >Youtube</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="ft-main-item">
                        <div class="line"></div>
                        <h2 class="ft-title">Contact</h2>
                        <ul>
                            <li>
                                <a href="#">curatorial@chi-athenaeum.org</a>
                            </li>
                            <li>
                                <a href="#"
                                    >tel: +1 815 777 4444 (extension 3000)</a
                                >
                            </li>
                        </ul>
                    </div>
                </section>
                <!-- Footer legal -->
                <section class="ft-legal">
                    &copy; 2024 - 2026 All rights reserved for The Chicago
                    Athenaeum Museum of Architecture and Design , European
                    centre for Architecture Art Design and Urban Studies,
                    Metropolitan Arts Press Ltd.
                </section>
            </footer>
        </el-row>
    </div>
</template>
<script>
import Footer from "@/core/components/Footer";
import Ticker from "@/core/components/Ticker.vue";

export default {
    components: {
        Ticker,
        Footer,
    },
    methods: {
        isMobile() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                )
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
};
</script>
<style>
ul {
    list-style: none;
    padding-left: 0;
}
footer {
    line-height: 1.5;
}
footer a {
    text-decoration: none;
}
a {
    color: #000000;
}
a:hover {
    text-decoration: underline;
}
.ft-title {
    font-weight: bold;
    font-size: 16px;
}
body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}
.container {
    flex: 1;
}
.ft-main {
    padding: 1.25rem 1.875rem;
    display: flex;
    flex-wrap: wrap;
}
@media only screen and (min-width: 29.8125rem /* 477px */) {
    .ft-main {
        justify-content: space-evenly;
    }
}
@media only screen and (min-width: 77.5rem /* 1240px */) {
    .ft-main {
        justify-content: space-evenly;
    }
}
.ft-main-item {
    padding: 1.25rem;
    min-width: 12.5rem;
    .line {
        width: 100%;
        border: 1px solid #000;
        margin: 3px;
        display: inline-block;
    }
}
.ft-legal {
    display: flex;
    justify-content: center;
    align-items: center;
}
.landing-tutorial {
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 16px;
    width: 100%;
    justify-content: center;
    margin-top: 30pt;
    a {
        text-decoration: underline;
    }
    img {
        display: none;
    }
    @media (max-resolution: 1dppx) {
        font-size: 30px;
        text-align: left;
        img {
            width: 110px;
            height: 85px;
            display: inline;
        }
    }
}
</style>
